import React from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import './RamaSwamySection.css';
import parse from "html-react-parser";

const InterviewBanner = ({ webpageData }) => {
  const interviewBannerData = webpageData?.interviewBannerData || {};
  const imgCDNURL = process.env.REACT_APP_CDN_LINK + "ussaic/";

  return (
    <div className="interview-banner">
      <div className="ramaswamy-bg">
        <Container>
          <Row className="align-items-center">
            <Col lg={7}>
              <div className="content-section">
                <h1 className="banner-title">
                  {parse(interviewBannerData.interviewTitle || "")} <br />
                  <span className="highlight">{parse(interviewBannerData.interviewHighlight || "")}</span>
                </h1>
                <p className="banner-description">
                  {parse(interviewBannerData.interviewDescription || "")}
                </p>
              </div>

              <div className="personram-info-desktop">
                <div className="personram-info">
                  <h3 className="personram-name">{parse(interviewBannerData.interviewName || "")}</h3>
                  <p className="personram-title">{parse(interviewBannerData.interviewTitleText || "")}</p>
                  <p className="personram-title-mobile">{parse(interviewBannerData.interviewTitleTextMobile || "")}</p>
                </div>
              </div>
            </Col>

            <Col lg={5}>
              <div className="image-section">
                <div className="personram-card">
                  <div className="personram-image">
                    <img
                      src={imgCDNURL + "Vivek-Ramaswamy.webp"}
                      alt="Vivek Ramaswamy"
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>

              <div className="personram-info-mobile">
                <div className="personram-info">
                  <h3 className="personram-name">{parse(interviewBannerData.interviewName || "")}</h3>
                  <p className="personram-title">{parse(interviewBannerData.interviewTitleText || "")}</p>
                  <p className="personram-title-mobile">{parse(interviewBannerData.interviewTitleTextMobile || "")}</p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default InterviewBanner;
